import React, { useRef, useState } from 'react';

import uploadIcon from 'assets/pics/uploadIcon.svg';
import PropTypes from 'prop-types';

import { FORM_CONSTANTS } from 'global/constants';

import { prepFilesForUpload } from 'utils/FileUtil';

const getDocumentUploaderClassName = (filesLength, onDrag) => {
  if (filesLength > 0 && onDrag === 0) {
    return 'upload-box active';
  }

  if (onDrag) {
    return 'upload-box drag';
  }

  return 'upload-box';
};

const calcNewEvent = (event, files) => ({
  ...event,
  target: { ...event.target, files },
  currentTarget: { ...event.currentTarget, files },
});

export const DragSection = ({ children, setFiles, files, setUnsupportedFilesCount }) => {
  const inputRef = useRef(null);

  const [onDrag, setOnDrag] = useState(false);

  const onFileChange = async (event) => {
    const newFiles = event.currentTarget.files;

    if (!newFiles) {
      return;
    }

    const newFilesB64 = await prepFilesForUpload(newFiles);
    setFiles([...files, ...newFilesB64]);
  };
  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files).filter((file) =>
      FORM_CONSTANTS.ACCEPTED_FORM_INPUT_FILE_TYPES.includes(file.type)
    );
    setUnsupportedFilesCount(event.target.files.length - selectedFiles.length);

    onFileChange(calcNewEvent(event, selectedFiles));
  };

  const handleDrop = (event) => {
    setOnDrag(false);

    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;

    if (!droppedFiles.length) {
      return;
    }

    const newFiles = Array.from(droppedFiles);
    const selectedFiles = newFiles.filter((file) =>
      FORM_CONSTANTS.ACCEPTED_FORM_INPUT_FILE_TYPES.includes(file.type)
    );

    onFileChange(calcNewEvent(event, selectedFiles));
  };

  return (
    <section
      className="drag-drop"
      onDragEnter={() => {
        setOnDrag((val) => val + 1);
      }}
      onDragLeave={() => {
        setOnDrag((val) => val - 1);
      }}>
      <input
        type="file"
        ref={inputRef}
        hidden
        id="browse"
        onChange={handleFileChange}
        accept=".pdf, .png, .gif, .jpg, .jpeg"
        multiple
      />
      <div
        className={`document-uploader ${getDocumentUploaderClassName(files.length, onDrag)}`}
        onDrop={handleDrop}
        onClick={() => {
          inputRef.current.click();
        }}
        onDragOver={(event) => event.preventDefault()}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key !== 'Enter' && event.key !== ' ') {
            return;
          }

          event.preventDefault();
          inputRef.current.click();
        }}>
        <div className="upload-info">
          <img className="svg" src={uploadIcon} alt="upload icon" />
          <div>
            <p>
              Dateien hier per Drag-and-Drop einfügen oder zum <a>Hochladen anklicken</a>
            </p>
          </div>
        </div>

        {children}
      </div>
    </section>
  );
};

DragSection.propTypes = {
  children: PropTypes.any,
  files: PropTypes.array.isRequired,
  setFiles: PropTypes.func.isRequired,
  setUnsupportedFilesCount: PropTypes.func.isRequired,
};

DragSection.defaultProps = {
  children: null,
};
